import styled from '@emotion/styled'
import SVG from '../../assets/svg'
import { size } from '../../styles'

interface Props {
   onClick?: () => void
   className?: string
}
const BackButton: React.FC<Props> = (props) => {
   const { onClick, className } = props
   return (
      <Holder className={'back-button ' + (className || '')} onClick={onClick}>
         <SVG.form.arrowLeft />
         <p>Back</p>
      </Holder>
   )
}

const Holder = styled.div`
   display: flex;
   align-items: center;
   cursor: pointer;
   gap: 0.7em;
   padding: 0.5em 1em;
   padding-left: 0;
   width: fit-content;
   border-radius: 1.3em;
   color: #4d4d4d;
   transition: all 0.2s ease-in-out;
   font-size: ${size.m};

   svg {
      width: 1.2em;
      fill: currentColor;
   }

   p {
      font-size: 1em;
      color: inherit;
      line-height: 0;
   }

   &:hover {
      background-color: #e0e0e0;
      padding-left: 1em;
   }
`
export default BackButton
